module.exports = __webpack_public_path__ + "img/05.604aa690.jpg";